<template>
  <div class="homescreen-bookmark-toggle">
    <a :class="['agenda-block-bookmarked', 'base-bookmarked', 'hs-agenda-bookmarked-' + scheduleItemLocation.id]"
       :id="scheduleItemLocation.id"
       tabindex="0"
       :data-url="destroyUrl"
       :data-bookmark="scheduleItemLocation.bookmark"
       :data-tags="scheduleItemLocation.tags"
       :aria-label="'Remove bookmark for schedule item ' + nameWithNoTags">
      <i class="fa fa-bookmark"></i>
    </a>
    
    <a :class="['agenda-block-bookmark', 'base-bookmark', 'hs-agenda-bookmark-' + scheduleItemLocation.id]"
       :id="scheduleItemLocation.id"
       tabindex="0"
       :data-name="scheduleItemLocation.name"
       :data-url="storeUrl"
       :data-bookmark="scheduleItemLocation.bookmark"
       :data-tags="scheduleItemLocation.tags"
       :aria-label="'Add bookmark for schedule item ' + nameWithNoTags">
      <i class="far fa-bookmark"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    scheduleItemLocation: Object,
    eventAttendee: Object,
    event: Object,
    nameWithNoTags: String,
    destroyUrl: String,
    storeUrl: String
  }
}
</script>

<style scoped>
.homescreen-bookmark-toggle {
  animation: fadeIn 0.5s;
}
</style>